var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.118,
    height: 34.124,
    viewBox: "0 0 34.118 34.124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-chatboxes",
    "data-name": "Icon ionic-ios-chatboxes",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7284",
    "data-name": "Trazado 7284",
    d: "M32.99,11.981H14.811a3.13,3.13,0,0,0-3.126,3.126V27.765a3.123,3.123,0,0,0,3.126,3.117h10.4a.9.9,0,0,1,.623.263l5.168,4.766c.287.279.763.164.763-.238V31.522c0-.492.312-.648.8-.648h.082a3.415,3.415,0,0,0,3.454-3.117V15.107A3.112,3.112,0,0,0,32.99,11.981Z",
    transform: "translate(1.386 1.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7285",
    "data-name": "Trazado 7285",
    d: "M13.744,11.406H28.3V6.049a2.675,2.675,0,0,0-2.674-2.674H6.049A2.675,2.675,0,0,0,3.375,6.049V19.6a2.675,2.675,0,0,0,2.674,2.674h5.012v-8.2A2.687,2.687,0,0,1,13.744,11.406Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.cef9669bfb321f96ba7ad3fd72a0db40.svg";
export { ForwardRef as ReactComponent };